
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Tabs } from "antd";
import { LeftCircleFilled } from "@ant-design/icons";
import GatewayApi from "../../../../api/GatewayApi";
import ViewStateService from "../../../../services/view-state/ViewStateService";
import GatewaySettings from "./components/gateway-settings/GatewaySettings";
import GatewayInformation from "./components/gateway-information/GatewayInformation";
import GatewaySlaveDevices from "./components/gateway-slave-devices/GatewaySlaveDevices";
import { GatewayDetailsWrapper, DeviceNameTitle, GoBackText, GoBackWrapper, TitleBar } from "./GatewayDetails.styled";
import GatewayDataDebug from "./components/gateway-data-debug/GatewayDataDebug";

interface GatewayDetailsProps {
    onClose: ()=> void,
    onComplete: ()=> void
}

const GatewayDetails: React.FC<GatewayDetailsProps> = (props)=> {
    // api
    let navigate = useNavigate();
    let location = useLocation();
    let viewStateService = ViewStateService.getInstance();
    let gatewayApi = new GatewayApi();

    // parameters
    let {gatewayId} = useParams();
    let [searchParams] = useSearchParams();
    let defaultTabKey = searchParams.get('tab') || 'gateway-information';

    // state
    let [gatewayView, setGatewayView] = useState(null);

    // events
    let loadGateway = async ()=> {
        if(!gatewayId) {
            return;
        }

        let gatewayView = (await gatewayApi.getGatewayViewByGatewayId(gatewayId)).data.data;
        setGatewayView(gatewayView);
    }

    let onGoBack = ()=> {
        if(location.key=='default') {
            navigate("/gateway-management");
        } else {
            navigate(-1);
        }
    }
    
    useEffect(()=> {
        // set status bar title
        viewStateService.setStatusBarTitle('网关详情');

        // load device information according to device id parameter
        loadGateway();

    }, []);
    
    // render
    let tabItems = [
        {
            key: 'gateway-information',
            label: '网关信息',
            children: gatewayView && <GatewayInformation gatewayView={gatewayView} />
        },
        {
            key: 'gateway-settings',
            label: '网关设置',
            children: gatewayView && <GatewaySettings gatewayView={gatewayView} />
        },
        {
            key: 'slave-devices',
            label: '子设备',
            children: gatewayView && <GatewaySlaveDevices gatewayView={gatewayView} />
        },
        {
            key: 'data-debug',
            label: '数据调试',
            children: gatewayView && <GatewayDataDebug gatewayView={gatewayView} />
        },
    ];

    return (
        <GatewayDetailsWrapper>
            <TitleBar>
                <GoBackWrapper onClick={onGoBack}>
                    <LeftCircleFilled style={{fontSize: '20px'}} />
                    <GoBackText>返回</GoBackText>
                </GoBackWrapper>
                <DeviceNameTitle>{gatewayView?.gateway.name}</DeviceNameTitle>
            </TitleBar>
    
            { gatewayView && 
                <Tabs
                    defaultActiveKey={defaultTabKey}
                    items={tabItems}
                    style={{flex: '1 1 auto', overflow: 'hidden'}}
                />
            }
        </GatewayDetailsWrapper>
    )
}

export default GatewayDetails;

